export default "__VITE_ASSET__DUShVRVH__"